import { useEffect } from "react";

export const useClickOutside = (ref, onClickOutside) => {
  useEffect(() => {
    const handleClickOutside = (event) => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (target?.closest?.(".MuiDialog-root, .MuiModal-root, .MuiPopover-root, .MuiMenu-root")) {
        return;
      }
      if (ref.current && !ref.current.contains(event.target)) {
        onClickOutside(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [ref, onClickOutside]);
};
